import React, { useEffect, useState } from "react";
// import "./discounts.scss";
import Banner from "../../assets/images/discount/banner.svg";
import PartnerBanner from "../../assets/images/discount/partners.png";
import { ReactComponent as Jaanuu } from "../../assets/images/discount/jaanuu-logo-2024 1.svg";
import { ReactComponent as Cryptotax } from "../../assets/images/discount/cryptotax.svg";

import { ReactComponent as Comrad } from "../../assets/images/discount/comrad.svg";
import SoFi from "../../assets/images/discount/sofi-logo.png";

import { ReactComponent as Native } from "../../assets/images/discount/native.svg";

import { ReactComponent as Paleovalley } from "../../assets/images/discount/paleovalley.svg";
import { ReactComponent as Cyty } from "../../assets/images/discount/cyty.svg";
import { ReactComponent as Bulb } from "../../assets/images/discount/new-deals/bulb.svg";
import { ReactComponent as Cap } from "../../assets/images/discount/new-deals/cap.svg";
import { ReactComponent as Bed } from "../../assets/images/discount/new-deals/bed.svg";
import { ReactComponent as Purce } from "../../assets/images/discount/new-deals/purse.svg";
import { ReactComponent as Birds } from "../../assets/images/discount/new-deals/birds.svg";
import { ReactComponent as Copy } from "../../assets/images/discount/copy.svg";
import { Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { activityEnd, activityStart } from "../../redux/slices/trackActivitySlice";
import usePageTracking from "../../hooks/usePageTracking";

// Optimized banner component with loading state
const OptimizedBanner = ({ src, alt = "" }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div className={`optimized-banner ${loaded ? 'loaded' : 'loading'}`}>
      {!loaded && (
        <div className="banner-placeholder">
          <div className="placeholder-shimmer" />
        </div>
      )}
      <img
        src={src}
        alt={alt}
        className={loaded ? 'fade-in' : 'hidden'}
        loading="eager"
        decoding="async"
        fetchPriority="high"
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};

// Preload banner images on mount
const usePreloadBanners = () => {
  useEffect(() => {
    const images = [Banner, PartnerBanner];
    images.forEach((src) => {
      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = src;
      document.head.appendChild(link);
    });
  }, []);
};

const Discounts = () => {
  const [activeTab, setActiveTab] = React.useState('partners');

  const dispatch = useDispatch();

  // Preload both banner images
  usePreloadBanners();

  // Track Activity 
  usePageTracking("DEALS");
  
    useEffect(() => {
          const payload = {
            page_name: "DEALS",
            platform: "web",
          };
      
          dispatch(activityStart(payload));
        }, [dispatch]);
      
        useEffect(() => {
          return () => {
            dispatch(
              activityEnd({
                page_name: "DEALS",
              }),
            );
          };
        }, [dispatch]);


  




  const partnerData = [
    {
      logo: <img src={SoFi} alt="" />,
      link: "https://www.sofi.com/multi/6726019/",
    }
  ]


  const discountsData = [
    {
      logo: <Jaanuu />,
      title: "25% OFF",
      tag: "Clothing",
      desc: "Premium medical apparel designed for comfort & performance..",
      code: "MAPMYPAY",
      btn: "Shop Now",
      link: " https://www.jaanuu.com",
    },
    {
      logo: <Cyty />,
      title: "15% OFF",
      tag: "Scrubs",
      desc:
        "Modern, comfortable scrubs designed for everyday medical professionals.",
      code: "MMP25",
      btn: "Shop Now",
      link: " https://shop.cytywear.com",
    },
    {
      logo: <Paleovalley />,
      title: "40% OFF",
      tag: "Snacks",
      desc: "Healthy, nutrient-rich snacks made with clean, real ingredients.",
      code: "",
      btn: "Claim Discount",
      link: "   https://paleovalley.com",
    },
    {
      logo: <Native />,
      title: "15% OFF",
      tag: "Shoes",
      desc:
        "Lightweight, comfortable, and eco-friendly footwear for everyday wear.",
      code: "MAPMYPAY15",
      btn: "Shop Now",
      link: " https://www.nativeshoes.com",
    },
    {
      logo: <Comrad />,
      title: "20% OFF on Socks",
      tag: "Socks",
      desc:
        "Premium compression socks designed for comfort, support & all-day performance.",
      code: "MAPMYPAY20",
      btn: "Shop Now",
      link: " https://www.comradsocks.com",
    },
    // {
    //   logo: <Cryptotax />,
    //   title: "0% OFF",
    //   tag: "Crypto Taxes",
    //   desc:
    //     "Smart and accurate crypto tax calculation tools to simplify your tax filing.",
    //   code: "MAPMYPAY20",
    //   btn: "Shop Now",
    //   link: "https://www.cointracker.io/",
    // },
  ];

  const newDeals = [
    {
      thumb: <Birds />,
      title: "Loop Earplugs - Black Friday: 25% off",
      tag: "25% OFF",
    },
    {
      thumb: <Bulb />,
      title: "Loop Earplugs - Black Friday: 25% off",
      tag: "25% OFF",
    },
    {
      thumb: <Cap />,
      title: "Loop Earplugs - Black Friday: 25% off",
      tag: "25% OFF",
    },
    {
      thumb: <Purce />,
      title: "Loop Earplugs - Black Friday: 25% off",
      tag: "25% OFF",
    },
    {
      thumb: <Bed />,
      title: "Loop Earplugs - Black Friday: 25% off",
      tag: "25% OFF",
    },
    {
      thumb: <Birds />,
      title: "Loop Earplugs - Black Friday: 25% off",
      tag: "25% OFF",
    },
  ];

  const [copiedIndex, setCopiedIndex] = React.useState(null);

  const copyCode = (code, index) => {
    if (!code) return;

    navigator.clipboard.writeText(code);

    // show tickmark for clicked item
    setCopiedIndex(index);

    // reset after 1.5 sec
    setTimeout(() => {
      setCopiedIndex(null);
    }, 1500);
  };

  const openLink = (url) => {
    if (url) window.open(url, "_blank");
  };





  return (
    <div className="discounts-page">
      {/* HEADER TITLE */}

      <div className="app-page-title discounts-page-title">
        <div className="page-title-heading">
          <h3
            className={`page-title ${activeTab === 'partners' ? 'active' : ''}`}
            onClick={() => setActiveTab('partners')}
            style={{ cursor: 'pointer' }}
          >
            Partners
          </h3>
          <h3
            className={`page-title ${activeTab === 'discounts' ? 'active' : ''}`}
            onClick={() => setActiveTab('discounts')}
            style={{ cursor: 'pointer' }}
          >
            Discounts
          </h3>
        </div>
      </div>

      {activeTab === 'discounts' && (
        <div className="discounts-page-content">
          <div className="main-content">
            <div className="header-banner">
              <OptimizedBanner src={Banner} alt="Discounts banner" />
            </div>

            <div className="content-area">
              {discountsData.map((item, i) => (
                <div className="discount-card" key={i}>
                  <div className="content-wrap">
                    <div className="logo-box">
                      {typeof item.logo === "string" ? (
                        <img src={item.logo} alt="brand" />
                      ) : (
                        item.logo
                      )}
                    </div>

                    <div className="discount-info">
                      <div className="discount-top">
                        <div className="title">{item.title}</div>
                        <span className="tag">{item.tag}</span>
                      </div>

                      <div className="desc">{item.desc}</div>
                    </div>

                    <div className="action-box">
                      {item.code && (
                        <button
                          className="code-box"
                          onClick={() => copyCode(item.code, i)}
                        >
                          {item.code}
                          <span className="copy-icon">
                            {copiedIndex === i ? (
                              <span className="tick">✓</span>
                            ) : (
                              <Copy />
                            )}
                          </span>
                        </button>
                      )}

                      <button
                        className="btn btn-primary"
                        onClick={() => openLink(item.link)}
                      >
                        {item.btn}
                      </button>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>

          <div className="sidebarcontent">
            <div className="sidebar-with-title">
              <h5>New Deals</h5>
              <div className="right-sidebar">
                <Card>
                  <Card.Body className="p-0">
                    <div className="new-deals-list">
                      {newDeals.map((deal, i) => (
                        <div className="deal-item" key={i}>
                          <div className="deal-thumb">
                            {typeof deal.thumb === "string" ? (
                              <img src={deal.thumb} alt="deal" />
                            ) : (
                              deal.thumb
                            )}
                          </div>

                          <div className="deal-info">
                            <div className="deal-title">{deal.title}</div>
                            <span className="deal-tag">{deal.tag}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>
      )}
      {activeTab === 'partners' && (
        <div className="discounts-page-content">
          <div className="main-content">
            <div className="header-banner">
              <OptimizedBanner src={PartnerBanner} alt="Partners banner" />
            </div>
            <div className="partner-grid row g-3">
              {partnerData.map((item, i) => (
                <div
                  className="partner-card col-6 col-md-4"
                  key={i}
                  onClick={() => openLink(item.link)}
                >
                  <div className="content-wrap">
                    <div className="logo-box">
                      {typeof item.logo === "string" ? (
                        <img src={item.logo} alt="brand" />
                      ) : (
                        item.logo
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div className="sidebarcontent">
            <div className="sidebar-with-title">
              <h5>New Deals</h5>
              <div className="right-sidebar">
                <Card>
                  <Card.Body className="p-0">
                    <div className="new-deals-list">
                      {newDeals.map((deal, i) => (
                        <div className="deal-item" key={i}>
                          <div className="deal-thumb">
                            {typeof deal.thumb === "string" ? (
                              <img src={deal.thumb} alt="deal" />
                            ) : (
                              deal.thumb
                            )}
                          </div>

                          <div className="deal-info">
                            <div className="deal-title">{deal.title}</div>
                            <span className="deal-tag">{deal.tag}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};

export default Discounts;
